export default __webpack_public_path__ + "static/media/min4.5917cb15.jpg";